import React, { useCallback, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Footer from "./Components/common/Footer";
import Header from "./Components/common/Header";
import CustomRoutes from "./router/CustomRoutes";
import SEOHelmet from "./Components/common/seohelmet";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const userLanguage =
      navigator.language || navigator.userLanguage || "tr";

    if (userLanguage.toLowerCase().startsWith("tr") && i18n.language !== "tr") {
      i18n.changeLanguage("tr");
    }
  }, [i18n]);

  const changeLanguage = useCallback(
    (lng) => {
      if (i18n.language !== lng) {
        i18n.changeLanguage(lng);
      }
    },
    [i18n]
  );

  return (
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <SEOHelmet />

        <Header changeLanguage={changeLanguage} />

        <CustomRoutes changeLanguage={changeLanguage} />

        <Footer changeLanguage={changeLanguage} />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;